import { RecoilEnv } from 'recoil';

// In development with HMR, Recoil atoms/selectors can be registered more than once,
// which triggers "Duplicate atom key" warnings. This setting disables that check.
if (process.env.NODE_ENV === 'development') {
    RecoilEnv.RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED = false;
}